import type { FC } from "react";

import type { IImageBanner } from "../common/ImageBanner";
import DiscountBanner from "./DiscountBanner";
import type { IDiscountCouponMobileOnly } from "./DiscountCouponMobileOnly";
import { DiscountCouponMobileOnly } from "./DiscountCouponMobileOnly";

import * as portalCss from "../shared/Portal.module.css";
import * as css from "./DiscountLandingPage.module.css";

export interface IDiscountLandingPage {
    discountImage: IImageBanner;
    discountCoupon: IDiscountCouponMobileOnly;
}

export const DiscountLandingPage: FC<IDiscountLandingPage> = (props: IDiscountLandingPage) => (
    <div className={css.discountLandingPageComponent}>
        <DiscountBanner id="" discountImage={props.discountImage} />
        <div className={`${portalCss.standardContainer} ${css.content}`}>
            <div className={css.validity}>
                <p className={css.validityText}>Ważna od 2018.10.15 do 2018.11.18</p>
            </div>
            <div className={css.downloadBanner}>
                <DiscountCouponMobileOnly {...props.discountCoupon} />
            </div>
            <div className={css.descriptionText}>
                <p>
                    Mała pizza z dwoma składnikami gratis tylko dla <ins>nowych</ins> użytkowników goodie!
                </p>
                <p>
                    Oferta ważna w lokalach Telepizzy lub przy zamówieniu online za min. 25 zł, wyłącznie z
                    kodem rabatowym z aplikacji goodie.
                </p>
                <p>
                    Regulamin promocji znajdziesz{" "}
                    <a
                        target="_blank"
                        href="https://documents.goodie.pl/discounts/Regulamin_Promocji_mala_pizza_gratis_14.10.2018.pdf"
                        rel="noreferrer"
                    >
                        tutaj
                    </a>
                    .
                </p>
            </div>
        </div>
    </div>
);

export default DiscountLandingPage;
